import { ENVIRONMENT_INITIALIZER, inject, makeEnvironmentProviders } from '@angular/core';
import { GlameraIconRegistry } from './icon-registry';
import { GlameraIconDefinition } from '@glamera/animated-icons/core';

/**
 * Standalone registration for `<glamera-icon name="...">`.
 * Pass only the icon definitions the app actually imports.
 *
 * `<glamera-icon>` ships base styles only. Add animation styles explicitly, for example:
 * `@import '@glamera/animated-icons/styles/search.scss';` in `angular.json`, or import
 * only the dedicated icon components which bundle their own animation CSS.
 */
export function provideGlameraIcons(icons: GlameraIconDefinition[]) {
  return makeEnvironmentProviders([
    {
      provide: ENVIRONMENT_INITIALIZER,
      multi: true,
      useValue: () => {
        inject(GlameraIconRegistry).register(icons);
      },
    },
  ]);
}
